export function useLanguage<T>(
    memberPrimaryLanguage: string,
    {
        spanish,
        english,
    }: {
        spanish: T;
        english: T;
    },
): T {
    return (memberPrimaryLanguage || '').toLowerCase() === 'spanish' ? spanish : english;
}
